"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const reducers_1 = require("../reducers");
const getCampaignType_1 = require("../views/utils/getCampaignType");
exports.createEditableCampaign = (id) => (dispatch, getState) => {
    const state = getState();
    const campaign = reducers_1.getCampaign(state, id);
    const { trigger, deliverable, UIState } = campaign, rest = __rest(campaign, ["trigger", "deliverable", "UIState"]);
    const parsedUIState = UIState.length > 0 ? JSON.parse(UIState) : null;
    const getCampaignDeliveryUIState = () => {
        if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
            return {
                dateAndTime: {
                    seen: false,
                    type: 'scheduleddelivery',
                },
                audience: {
                    seen: false,
                    type: 'scheduleddelivery',
                    conditionSelected: 'ALL',
                },
            };
        }
        if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
            return {
                eventTrigger: {
                    seen: false,
                    type: 'automateddelivery',
                },
                campaignDuration: {
                    seen: false,
                    type: 'automateddelivery',
                },
                frequencyLimits: {
                    seen: false,
                    type: 'automateddelivery',
                },
                audience: {
                    seen: false,
                    type: 'automateddelivery',
                    conditionSelected: 'ALL',
                },
            };
        }
        if (getCampaignType_1.isAPICampaignTrigger(trigger)) {
            return {
                apiTrigger: {
                    seen: false,
                    type: 'delivery',
                },
                audience: {
                    seen: false,
                    type: 'delivery',
                    conditionSelected: 'ALL',
                },
            };
        }
    };
    dispatch({
        type: 'CREATE_EDITABLE_CAMPAIGN',
        editableCampaign: Object.assign({ trigger,
            deliverable }, rest),
    });
    dispatch({
        type: 'CREATE_EDITABLE_UI_STATE',
        editableUIState: Object.assign(Object.assign({ messageAndMedia: {
                seen: false,
                type: 'notification',
            }, alertOptions: {
                seen: false,
                type: 'notification',
            }, tapBehavior: {
                seen: false,
                type: 'notification',
            }, advancedSettings: {
                seen: false,
                type: 'notification',
            } }, getCampaignDeliveryUIState()), parsedUIState),
    });
};
exports.unsetEditableCampaign = () => (dispatch, getState) => {
    dispatch({
        type: 'UNSET_EDITABLE_CAMPAIGN',
        editableCampaign: {},
    });
    dispatch({
        type: 'UNSET_EDITABLE_UI_STATE',
        editableUIState: {},
    });
};
exports.updateEditableCampaign = (campaignField) => (dispatch, getState) => {
    const editableCampaign = Object.assign(Object.assign({}, getState().editableCampaign), campaignField);
    dispatch({
        type: 'UPDATE_EDITABLE_CAMPAIGN',
        editableCampaign,
    });
};
const updateDeliverable = (deliverable) => (dispatch) => {
    dispatch(exports.updateEditableCampaign({ deliverable }));
};
exports.updateNotificationDeliverable = (updatedDeliverableFields) => (dispatch, getState) => {
    const state = getState();
    const { deliverable } = reducers_1.getEditableCampaign(state);
    dispatch(updateDeliverable(Object.assign(Object.assign({}, deliverable), updatedDeliverableFields)));
};
const updateTrigger = (trigger) => (dispatch) => dispatch(exports.updateEditableCampaign({ trigger }));
exports.updateAutomatedCampaignTrigger = (updatedTriggerFields) => (dispatch, getState) => {
    const state = getState();
    const trigger = reducers_1.getEditableCampaignAutomatedCampaignTrigger(state);
    dispatch(updateTrigger(Object.assign(Object.assign({}, trigger), updatedTriggerFields)));
};
exports.updateScheduledCampaignTrigger = (updatedTriggerFields) => (dispatch, getState) => {
    const state = getState();
    const trigger = reducers_1.getEditableCampaignScheduledCampaignTrigger(state);
    dispatch(updateTrigger(Object.assign(Object.assign({}, trigger), updatedTriggerFields)));
};
exports.updateEditableCampaignTriggerSegment = (segment) => (dispatch, getState) => {
    const state = getState();
    const { trigger } = reducers_1.getEditableCampaign(state);
    return dispatch(updateTrigger(Object.assign(Object.assign({}, trigger), { segment: segment })));
};
exports.updateAutomatedEventTrigger = (updatedEventTriggerFields) => (dispatch, getState) => {
    const state = getState();
    const eventTrigger = reducers_1.getEditableCampaignEventTrigger(state);
    dispatch(exports.updateAutomatedCampaignTrigger({
        eventTrigger: Object.assign(Object.assign({}, eventTrigger), updatedEventTriggerFields),
    }));
};
exports.updateEventTriggerFilters = (newFilter) => (dispatch, getState) => {
    const state = getState();
    const filters = reducers_1.getEditableCampaignEventTriggerFilters(state);
    const newFilters = filters.filter((f) => f.__typename !== newFilter.__typename).concat(newFilter);
    dispatch(exports.updateAutomatedEventTrigger({
        filters: newFilters,
    }));
};
exports.removeEventTriggerFilter = (filterName) => (dispatch, getState) => {
    const state = getState();
    const oldFilters = reducers_1.getEditableCampaignEventTriggerFilters(state);
    const filters = oldFilters.filter(({ __typename }) => __typename !== filterName);
    dispatch(exports.updateAutomatedEventTrigger({ filters }));
};
exports.updateScheduledEventTriggerFilter = (dateTime) => (dispatch, getState) => {
    const state = getState();
    const filters = reducers_1.getEditableCampaignEventTriggerFilters(state);
    const scheduledEventTriggerFilter = reducers_1.getEventTriggerFilterByType(filters, 'ScheduledEventTriggerFilter');
    dispatch(exports.updateEventTriggerFilters(Object.assign(Object.assign({ __typename: 'ScheduledEventTriggerFilter' }, scheduledEventTriggerFilter), dateTime)));
};
exports.updateTimeOfDayEventTriggerFilter = (timeOfDay) => (dispatch, getState) => {
    const state = getState();
    const filters = reducers_1.getEditableCampaignEventTriggerFilters(state);
    const timeOfDayEventTriggerFilter = reducers_1.getEventTriggerFilterByType(filters, 'TimeOfDayEventTriggerFilter');
    dispatch(exports.updateEventTriggerFilters(Object.assign(Object.assign({ __typename: 'TimeOfDayEventTriggerFilter' }, timeOfDayEventTriggerFilter), timeOfDay)));
};
exports.updateEventAttributeOperator = (operator) => (dispatch, getState) => {
    const state = getState();
    const eventAttributes = reducers_1.getEditableEventAttributesEventTriggerFilter(state);
    const newEventAttributes = {
        __typename: 'EventAttributesEventTriggerFilter',
        predicate: {
            predicates: eventAttributes ? eventAttributes.predicates : [],
            booleanOperator: operator,
        },
    };
    dispatch(exports.updateEventTriggerFilters(newEventAttributes));
};
exports.updateEventAttributePredicates = (predicates) => (dispatch, getState) => {
    const state = getState();
    const eventAttributes = reducers_1.getEditableEventAttributesEventTriggerFilter(state);
    if (eventAttributes) {
        const newEventAttributes = {
            __typename: 'EventAttributesEventTriggerFilter',
            predicate: Object.assign(Object.assign({}, eventAttributes), { predicates }),
        };
        dispatch(exports.updateEventTriggerFilters(newEventAttributes));
    }
};
exports.editPredicate = (index, predicate) => (dispatch, getState) => {
    const state = getState();
    const filters = reducers_1.getEditableEventAttributesEventTriggerFilter(state).predicates;
    const newFilters = [...filters.slice(0, index), predicate, ...filters.slice(index + 1)];
    return dispatch(exports.updateEventAttributePredicates(newFilters));
};
exports.addPredicate = (predicate) => (dispatch, getState) => {
    const state = getState();
    const filters = reducers_1.getEditableEventAttributesEventTriggerFilter(state).predicates;
    return dispatch(exports.updateEventAttributePredicates([...filters, predicate]));
};
exports.removePredicate = (index) => (dispatch, getState) => {
    const state = getState();
    const filters = reducers_1.getEditableEventAttributesEventTriggerFilter(state).predicates;
    const newFilters = [...filters.slice(0, index), ...filters.slice(index + 1)];
    return dispatch(exports.updateEventAttributePredicates(newFilters));
};
exports.updateFrequencyLimits = (limits) => (dispatch, getState) => {
    const state = getState();
    const { trigger } = reducers_1.getEditableCampaign(state);
    if (getCampaignType_1.isAPICampaignTrigger(trigger) || getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        dispatch(exports.updateEditableCampaign({
            trigger: Object.assign(Object.assign({}, trigger), { limits }),
        }));
    }
};
